import { createSlice } from '@reduxjs/toolkit';

import {
  getAllStoresApi,
  getAllCategoryApi,
  getStoreByStoreIdApi,
  getAllSubCategoryApi,
  getStateCityListApi,
  getStoreByCityApi,
  getAllStoresPaginatedApi,
  getTotalStoresCountApi,
  getNearestStoreApi
} from './storeApi';

// ----------------------------------------------------------------------

const initialState = {
  selectedStore: {},
  isStoreLoading: false,
  storeList: [],
  storeCityList: [],
  categoryList: [],
  subCategoryList: [],
  getNearestStore: [],
  storeSelected: null,
  stateCityList: {},
  storePaginatedPageNo: 0,
  storePaginatedPageSize: 50,
  totalStoreCount: {}
};

const slice = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    selectStore: (state, action) => {
      state.storeSelected = action.payload;
    },
    increaseStorePaginatedPageNo: (state, action) => {
      state.storePaginatedPageNo = action.payload;
    }
  },
  extraReducers: {
    [getAllStoresApi.pending]: (state) => {
      state.isStoreLoading = true;
      state.storeList = [];
    },
    [getAllStoresApi.fulfilled]: (state, action) => {
      state.storeList = action.payload;
      state.isStoreLoading = false;
    },
    [getAllStoresApi.rejected]: (state) => {
      state.isStoreLoading = false;
    },
    [getAllCategoryApi.fulfilled]: (state, action) => {
      state.categoryList = action.payload;
    },
    [getStoreByStoreIdApi.fulfilled]: (state, action) => {
      state.selectedStore = action.payload;
    },
    [getAllSubCategoryApi.pending]: (state, action) => {
      state.isSubCatLoading = true;
      state.subCategoryList = [];
    },
    [getAllSubCategoryApi.fulfilled]: (state, action) => {
      state.isSubCatLoading = false;
      state.subCategoryList = action.payload;
    },
    [getAllSubCategoryApi.rejected]: (state, action) => {
      state.isSubCatLoading = false;
      state.subCategoryList = [];
    },
    [getStateCityListApi.fulfilled]: (state, action) => {
      state.stateCityList = action.payload;
    },
    [getStoreByCityApi.fulfilled]: (state, action) => {
      state.storeCityList = action.payload;
    },
    [getAllStoresPaginatedApi.fulfilled]: (state, action) => {
      const { result = [], isAppend = false, hasMoreStoreData } = action.payload;
      state.hasMoreStoreData = hasMoreStoreData;
      state.isStoreLoading = false;
      state.storeList = result;
    },
    [getTotalStoresCountApi.fulfilled]: (state, action) => {
      state.totalStoreCount = action.payload;
    },
    [getNearestStoreApi.fulfilled]: (state, action) => {
      state.getNearestStore = action.payload;
    }
  }
});
export const { actions } = slice;
export const storeActions = slice.actions;

export default slice.reducer;
